module.exports = __webpack_public_path__ + "img/Particules_gauche.2b892191.svg";